import { Component, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { JkBaseComponent } from '../jkbase/jkbase.component';



@Component({
  selector: 'app-jkfab-button',
  templateUrl: './jkfab-button.component.html',
  styleUrls: ['./jkfab-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, MatButtonModule, MatBottomSheetModule,MatListModule ]
})
export class JkfabButtonComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'jkfab-button';
  //@Output()  cbQuery: (e?:any) => void;

  readonly queryChange = output<any>();
  onQueryChange(newValue: any) {
    this.queryChange.emit(newValue);
  }
  readonly insertChange = output<any>();
  onInsertChange(newValue: any) {
    this.insertChange.emit(newValue);
  }
  /*@Output() editChange = new EventEmitter<any>();
  onEditChange(newValue: any) {
    this.editChange.emit(newValue);
  }
  @Output() deleteChange = new EventEmitter<any>();
  onDeleteChange(newValue: any) {
    this.deleteChange.emit(newValue);
  }*/
  readonly refreshChange = output<any>();
  onRefreshChange(newValue: any) {
    this.refreshChange.emit(newValue);
  }
  readonly scrollTopChange = output<void>();
  onScrollTopChange() {
    this.scrollTopChange.emit();
  }
  /*
  @Output()  cbInsert: (e?:any) => void;
  @Output()  cbEdit: (item?:any) => void;
  @Output()  cbRefresh: (e?:any) => void;
  @Output()  cbDelete: (e?:any) => void;
  @Output()  cbBack: () => void;
  */
  /*_entity:JkEntityV2;
  @Input() set entity(ds:JkEntityV2){
    this._entity = ds;
    this.init(ds);
  }
  get entity(){
    return this._entity;
  }*/
  public readonly queryDisabled = input(false);
  public readonly insertDisabled = input(false);
  //@Input()  public editDisabled = false;
  public readonly refreshDisabled = input(false);
  //@Input()  public deleteDisabled = false;
  public readonly backDisabled = input(false);
  public readonly scrollTopDisabled = input(false);
  public navCtrl?: any;
  //constructor(private navCtrl: NavController) {
    constructor() {
    super();
      //this.navCtrl = nav;
   }

  override ngOnInit() {
    super.ngOnInit();
  }
  doQuery(e:any){
    if(this.onQueryChange)
      this.onQueryChange(e);
  }
  doInsert(e:any) {
    if(this.onInsertChange)
    this.onInsertChange(e);
  }
  doRefresh(e:any) {
    if(this.onRefreshChange)
    this.onRefreshChange(e);
  }
  doBack() {
    this.navCtrl.back();
  }
  doScrollTop() {
    if(this.onScrollTopChange)
    this.onScrollTopChange();
  }
}
